// Helpers de plantillas HSM (Meta) para el modal selector y el preview fiel. Doc 0367 (H7).
// Mismo criterio de sustitución que el backend (SendWabaTemplateUseCase).

// Regex de variable: {{n}} numérica o {{nombre}} nombrada. Meta soporta AMBAS (no mezcladas).
const varRegex = () => /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;

// Extrae las claves de variable, sin duplicados y en orden estable: si TODAS son numéricas
// (posicionales {{1}},{{2}}) se ordenan por número; si hay nombradas ({{customer_name}}) se
// usan en orden de aparición. Los valores del mapeo se alinean por la posición de la clave.
export const extractVarKeys = (text) => {
  const found = [];
  const re = varRegex();
  let m;
  while ((m = re.exec(String(text || ""))) !== null) {
    if (!found.includes(m[1])) found.push(m[1]);
  }
  const allNumeric = found.length > 0 && found.every((k) => /^\d+$/.test(k));
  return allNumeric ? found.slice().sort((a, b) => Number(a) - Number(b)) : found;
};

// Número de variables distintas (numéricas o nombradas).
export const countVars = (text) => extractVarKeys(text).length;

// Sustituye cada {{key}} por el valor en la posición de su clave. Si falta, deja el placeholder.
export const substituteVars = (text, vars = []) => {
  const keys = extractVarKeys(text);
  return String(text || "").replace(varRegex(), (_m, key) => {
    const idx = keys.indexOf(key);
    const v = idx >= 0 ? vars[idx] : undefined;
    return v != null && v !== "" ? v : `{{${key}}}`;
  });
};

const MEDIA_FORMATS = ["IMAGE", "VIDEO", "DOCUMENT"];

// Descompone los `components` de Meta en un modelo de UI plano para el modal/preview.
export const parseTemplate = (components = []) => {
  let header = null; // { format, text, isMedia, varCount }
  let body = { text: "", varCount: 0 };
  let footer = null; // { text }
  let buttons = []; // [{ type, text }]

  for (const c of components || []) {
    const type = String(c.type).toUpperCase();
    if (type === "HEADER") {
      const format = String(c.format || "TEXT").toUpperCase();
      const isMedia = MEDIA_FORMATS.includes(format);
      header = {
        format,
        text: c.text || "",
        isMedia,
        varCount: isMedia ? 0 : countVars(c.text),
        varKeys: isMedia ? [] : extractVarKeys(c.text),
      };
    } else if (type === "BODY") {
      body = { text: c.text || "", varCount: countVars(c.text), varKeys: extractVarKeys(c.text) };
    } else if (type === "FOOTER") {
      footer = { text: c.text || "" };
    } else if (type === "BUTTONS") {
      buttons = (c.buttons || []).map((b) => ({
        type: String(b.type || "").toUpperCase(),
        text: b.text || b.url || b.phone_number || "",
      }));
    }
  }
  return { header, body, footer, buttons };
};

// Construye el payload `variables` que espera el backend a partir de los inputs del modal.
export const buildVariablesPayload = ({ parsed, headerMediaUrl, headerTextVars, bodyVars }) => {
  const variables = {};
  if (parsed.header?.isMedia) {
    if (headerMediaUrl) variables.header = [headerMediaUrl];
  } else if (parsed.header?.varCount > 0) {
    variables.header = headerTextVars.slice(0, parsed.header.varCount);
  }
  if (parsed.body?.varCount > 0) {
    variables.body = bodyVars.slice(0, parsed.body.varCount);
  }
  return variables;
};

// Valida que todas las variables requeridas estén completas (para habilitar "Enviar").
export const isTemplateComplete = ({ parsed, headerMediaUrl, headerTextVars, bodyVars }) => {
  if (parsed.header?.isMedia && !String(headerMediaUrl || "").trim()) return false;
  if (parsed.header?.varCount > 0) {
    for (let i = 0; i < parsed.header.varCount; i++) {
      if (!String(headerTextVars[i] || "").trim()) return false;
    }
  }
  for (let i = 0; i < (parsed.body?.varCount || 0); i++) {
    if (!String(bodyVars[i] || "").trim()) return false;
  }
  return true;
};
